export default __webpack_public_path__ + "static/store-one.ko-9aebcef88abb0e0a3fc38865a9e58b76.png";